import {Injectable} from '@angular/core';
import {BsModalService} from 'ngx-bootstrap/modal';
import {ConfirmationPopupComponent, ConfirmationPopupConfig} from '@reusable/confirmation-popup.component';


@Injectable({
  providedIn: 'root'
})
export class ConfirmationPopupService {

  constructor(private modal: BsModalService) {
  }

  confirm(config: ConfirmationPopupConfig) {
    this.modal.show(ConfirmationPopupComponent, {
      initialState: {config},
      animated: true,
      keyboard: false,
      backdrop: true,
      ignoreBackdropClick: true,
    });
  }
}
